import {AxiosResponse} from "axios";
import {BaseMutationOptions, BaseUseMutationResult, useBaseMutation} from "@bounce/shared/requests";
import {axiosReachInstance} from "../../ReachApiManager";
import {ReachTemplateTestSendRequest, ReachTemplateTestSendResponse} from "./types";

const testSendTemplate = async (
  variables: ReachTemplateTestSendRequest
): Promise<ReachTemplateTestSendResponse> => {
  const response = await axiosReachInstance.post<
    ReachTemplateTestSendResponse,
    AxiosResponse<ReachTemplateTestSendResponse>,
    ReachTemplateTestSendRequest
  >("/templates/test-send", variables);
  return response.data;
};

export const useTestSendTemplate = (
  options?: BaseMutationOptions<ReachTemplateTestSendResponse, ReachTemplateTestSendRequest>
): BaseUseMutationResult<ReachTemplateTestSendResponse, ReachTemplateTestSendRequest> =>
  useBaseMutation<ReachTemplateTestSendResponse, ReachTemplateTestSendRequest>(testSendTemplate, options);
